import React from 'react'
import Icon from '@/components/Icon'
import LoadingIndicator from '@/components/LoadingIndicator'
import { useLocalization } from '@/hooks/localization'

export function TaskActivationButton ({
  taskId,
  activeTaskId,
  onActivate,
  onDeactivate,
  showText,
  activating,
  showButton
}) {
  const { localize } = useLocalization()
  if (!showButton) { return null }
  if (activating === true) { return <LoadingIndicator inline /> }

  const isActive = activeTaskId === taskId
  const handleClick = e => {
    e.preventDefault()
    isActive ? onDeactivate(taskId) : onActivate(taskId)
  }
  const icon = isActive ? 'stop-circle' : 'play-circle'
  const text = isActive ? 'Tasks.Stop' : 'Tasks.Start'
  let classN = isActive ? 'btn btn-warning' : 'btn btn-success'

  return (
    <button className={classN} onClick={handleClick}><Icon name={icon} /><span>{showText && localize && localize(text)}</span></button>
  )
}



// WEBPACK FOOTER //
// ./src/internal-app/components/tasks/taskActivationButton.js